import * as React from 'react';
import { DataSource } from '../../../shared/DataSource';
import { IBtnSelectOption } from '../BtnSelect';
import {CustomPeriodMultiBtnSelect} from '../CustomPeriodMultiBtnSelect';
import { MultiBtnSelect } from '../MultiBtnSelect';

export interface IMultiNode extends IBtnSelectOption {
  selectable?: boolean
  groupOption?: boolean
  nodes?: IMultiNode[]
}

interface IDataMultiBtnSelectProps {
  placeholder: string
  source: DataSource<IMultiNode, any>
  useMobileMode?: boolean
  persistLabel?: boolean
  values: string[]
  onChange?: (values: string[], source: IMultiNode[]) => void
  onClosed?: () => void
  showSpinner?: boolean
  defaultValue?: string
  disableClearOnFirstSelect?: boolean
  hidePopoverOnClear?: boolean
  hidePopoverOnLeadNodeSelect?: boolean
  hideFirstSelectWhen?: (source: IMultiNode[]) => boolean
  displayAllOption?: boolean
  showAllCoachingFormOption?: boolean
  useLinkView?: boolean
  rightAlign?: boolean

  updateDateRange: (startDate: Date, endDate: Date) => void
  hasLoadedEvent?: (hasLoaded: boolean) => void

  startDateRange: Date
  endDateRange: Date
  disableDatePicker: boolean
  disableSubmitButton?: boolean;
  isDataLoading?: boolean;
}

interface IDataMultiBtnSelectState {
  hasLoaded: boolean
  source: IMultiNode[]
}

export class CustomPeriodDataMultiBtnSelect extends React.Component<IDataMultiBtnSelectProps, IDataMultiBtnSelectState> {
  state: IDataMultiBtnSelectState = {
    source: [],
    hasLoaded: false,
  }

  hasMount = false
  removeOnSyncListener: () => void = () => ({})

  componentWillMount() {
    this.removeOnSyncListener = this.props.source.onSync(({ records: source }) => {
      const hasLoaded = true
      this.setState({ hasLoaded: hasLoaded, source })
    })

    this.props.source.sync()
  }

  componentDidMount() {
    this.hasMount = true
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.hasLoaded !== this.state.hasLoaded) {
      this.props.hasLoadedEvent(this.state.hasLoaded)
    }
  }


  componentWillUnmount() {
    this.removeOnSyncListener()
  }

  onChange(newValues: string[]) {
    const { onChange = () => ({}) } = this.props

    onChange(newValues, this.state.source);

    if (this.hasMount && this.state.hasLoaded) {
      this.props.source.syncDependencies()
    }
  }

  render() {
    const { hasLoaded, source = [] } = this.state
    const {
      values,
      showSpinner = !hasLoaded,
      defaultValue,
      hideFirstSelectWhen,
      showAllCoachingFormOption = false,
      updateDateRange,
      startDateRange,
      endDateRange,
      disableDatePicker,
      isDataLoading,
      disableSubmitButton
    } = this.props
    let hideFirstSelect = false

    if (hideFirstSelectWhen) {
      hideFirstSelect = hideFirstSelectWhen(source)
    }

    return (
      <CustomPeriodMultiBtnSelect
        isDataLoading={isDataLoading}
        persistLabel={this.props.persistLabel}
        placeholder={this.props.placeholder}
        useLinkView={this.props.useLinkView}
        rightAlign={this.props.rightAlign}
        onClosed={this.props.onClosed}
        values={values}
        disabled={!hasLoaded}
        source={source}
        onChange={(newValues) => this.onChange(newValues)}
        defaultValue={defaultValue}
        showSpinner={showSpinner}
        useMobileMode={this.props.useMobileMode}
        disableClearOnFirstSelect={this.props.disableClearOnFirstSelect}
        hidePopoverOnClear={this.props.hidePopoverOnClear}
        hidePopoverOnLeadNodeSelect={this.props.hidePopoverOnLeadNodeSelect}
        hideFirstSelect={hideFirstSelect}
        showAllCoachingFormOption={showAllCoachingFormOption}

        updateDateRange={(startDate, endDate) => {updateDateRange(startDate, endDate)}}
        startDateRange={startDateRange}
        endDateRange={endDateRange}
        disableDatePicker={disableDatePicker}
        disableSubmitButton={disableSubmitButton}
      />
    )
  }
}
